import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { usePublisherWorkflowsModalT } from 'features/workflows/modals/use_publisher_workflows_modal_t'

import { isSmsDeactivatedPopupOpenSelector, closeSmsDeactivatedPopup } from '../slice'

export const SmsDeactivatedPopup = ({ onClose }) => {
  const wfT = usePublisherWorkflowsModalT()
  const dispatch = useDispatch()
  const isOpen = useSelector(isSmsDeactivatedPopupOpenSelector)
  const handleClose = onClose || (() => dispatch(closeSmsDeactivatedPopup()))

  return (
    <Popup
      isBlocking
      isOpen={isOpen}
      title={I18n.t('publisher.enforcement.sms_deactivated')}
      onClose={handleClose}
    >
      <Body>
        {wfT('publisher.workflows.sms_deactivated_modal.body')}
      </Body>

      <Footer>
        <Button onClick={handleClose}>
          {I18n.t('publisher.action.okay')}
        </Button>
      </Footer>
    </Popup>
  )
}
